import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export const alert = {
    success,
    error,
    // clear,
};

function success(Message) {
    toast.success(Message);
}

function error(Message) {
    toast.error(Message)
}
